var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcSCopy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5.538 5A.54.54 0 0 0 5 5.538v6.923a.54.54 0 0 0 .538.539h.77a1 1 0 1 1 0 2h-.77A2.54 2.54 0 0 1 3 12.461V5.538A2.54 2.54 0 0 1 5.538 3h6.923A2.54 2.54 0 0 1 15 5.538v.77a1 1 0 1 1-2 0v-.77A.54.54 0 0 0 12.461 5zm6 6a.54.54 0 0 0-.538.539v6.923c0 .297.241.538.539.538h6.923a.54.54 0 0 0 .538-.538v-6.923a.54.54 0 0 0-.538-.539zM9 11.539A2.54 2.54 0 0 1 11.539 9h6.923A2.54 2.54 0 0 1 21 11.539v6.923A2.54 2.54 0 0 1 18.462 21h-6.923A2.54 2.54 0 0 1 9 18.462z",
  clipRule: "evenodd"
})));
export default SvgIcSCopy;